// src/components/VersionInfo.jsx

import React from "react";
import { versionInfo } from "versionInfo";

function formatBuildDate(value) {
  if (!value) return "";

  const d = new Date(value);

  if (Number.isNaN(d.getTime())) {
    return value;
  }

  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
  });
}

export default function VersionInfo({
  compact = false,
}) {
  if (compact) {
    return (
      <div className="text-xs text-muted">
        v{versionInfo.version} · Build{" "}
        {versionInfo.buildNumber} ·{" "}
        {versionInfo.gitCommit}
      </div>
    );
  }

  return (
    <div className="space-y-1 text-xs text-muted">
      <div className="font-medium text-app">
        {versionInfo.appName}
      </div>

      <div>
        Version: v{versionInfo.version}
        {" · "}
        Build {versionInfo.buildNumber}
      </div>

      <div>
        Branch: {versionInfo.gitBranch}
        {" · "}
        Commit: {versionInfo.gitCommit}
      </div>

      <div>
        Built:{" "}
        {formatBuildDate(
          versionInfo.buildDate
        )}
      </div>
    </div>
  );
}